export default {
  openGraph: {
    type: 'website',
    locale: 'en_US',
    url: 'https://www.pricke.io',
    site_name: 'Prickle',
  },
};
